module.exports = __webpack_public_path__ + "static/media/video2.a9a03e36.mp4";